export const firebaseConfig = {
  apiKey: 'AIzaSyD-7qRYTyiT73NLocyfmf_JZZjlVX50J3k',
  authDomain: 'colivingly.firebaseapp.com',
  databaseURL: 'https://colivingly.firebaseio.com',
  storageBucket: 'colivingly.appspot.com'
};


// WEBPACK FOOTER //
// ./src/firebase/config.js